module.exports = __webpack_public_path__ + "static/background-1@2x-2a33fe988800fa9ab52f7fb0f8f5dd40.jpg";